module.exports = __webpack_public_path__ + "media/images/talent/lp/feature02-36c21e2100288d9f5c8eb2f52596866d.png";